import PrintTemplate from "../../../../components/reports/print-reports/print-template.jsx";
import ReportContent from "./report/report-content.jsx";

export default function Content({ id, reportData, data, entity, title, printComponentRef, setIsPrinting, printOptions }) {

    return (
        <>
            {reportData && data && (
                <PrintTemplate entity={entity} title={title} ref={printComponentRef} setIsPrinting={setIsPrinting}>
                    <div className="transform !-translate-y-[8.5px]"/>

                    <div className="w-full mt-[25px] print:mt-0">
                        <ReportContent
                            id={id}
                            data={reportData}
                            printOptions={printOptions}
                        />
                    </div>
                </PrintTemplate>
            )}
        </>
    )
}